import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ScrollSmoother from "./lib/ScrollSmoother.js";
import gsap from "gsap";
import "./App.css";

import CurvedSection from "./components/CurvedSection";
import WaveSection from "./components/WaveSection";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

function App() {
  /**
   * ScrollSmoother
   */
  useGSAP(() => {
    ScrollSmoother.create({
      smooth: 2,
      effects: true,
      sppeed: 1,
      normalizeScroll: false,

      // light source
      onUpdate: (self: any) => {
        const max = 400;
        const vel = Math.floor(self.getVelocity() / 2);

        gsap.to(".light-source", {
          ease: "power3",
          height: vel < 0 ? 0 : vel > max ? max : vel,
        });
      },
    });
  });

  return (
    <div className="App">
      {/* -- ALL YOUR CONTENT HERE -- */}
      <div id="smoother-wrapper">
        <div id="smooth-content">
          <div className="wrapper">
            {/* SECTION: Wave Plane */}
            <WaveSection />

            {/* SECTION: Cylinder to plane geometry */}
            <CurvedSection />
          </div>
        </div>
      </div>
      {/* -- position: fixed elements can go outside -- */}
      <div className="light-source"></div>
    </div>
  );
}

export default App;
